require("../styles/_Common.scss");

// const abiDecoder = require('abi-decoder'); // NodeJS ES6 doesn't Uglify

import React from "react";

class ABIchecker0xBounty extends React.Component {
    
    constructor(props) {
        super(props);
        
        this.state = {
            decodedLogs : ''
        };
        
        this.zeroxBountyABI = 
[{"constant":false,"inputs":[{"name":"_token","type":"address"},{"name":"_host","type":"address"},{"name":"_hunter","type":"address"},{"name":"_amount","type":"uint256"}],"name":"distributeTokenToAddress","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[{"name":"_token","type":"address"},{"name":"_amount","type":"uint256"}],"name":"depositToken","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[],"name":"unpause","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[{"name":"","type":"address"},{"name":"","type":"address"}],"name":"tokens","outputs":[{"name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"paused","outputs":[{"name":"","type":"bool"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"name":"_token","type":"address"},{"name":"_host","type":"address"},{"name":"_hunters","type":"address[]"},{"name":"_amounts","type":"uint256[]"}],"name":"distributeTokenToAddressesAndAmounts","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[{"name":"_token","type":"address"}],"name":"addSupportedToken","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[{"name":"_token","type":"address"}],"name":"removeSupportedToken","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[],"name":"pause","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[],"name":"owner","outputs":[{"name":"","type":"address"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"name":"_token","type":"address"},{"name":"_hunters","type":"address[]"},{"name":"_amounts","type":"uint256[]"}],"name":"distributeTokenToAddressesAndAmountsWithoutHost","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[{"name":"_from","type":"address"},{"name":"_value","type":"uint256"},{"name":"_data","type":"bytes"}],"name":"tokenFallback","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[{"name":"","type":"address"}],"name":"tokenIsSupported","outputs":[{"name":"","type":"bool"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"getListOfSupportedTokens","outputs":[{"name":"","type":"address[]"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"name":"newOwner","type":"address"}],"name":"transferOwnership","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"inputs":[],"payable":false,"stateMutability":"nonpayable","type":"constructor"},{"anonymous":false,"inputs":[{"indexed":false,"name":"token","type":"address"},{"indexed":false,"name":"user","type":"address"},{"indexed":false,"name":"amount","type":"uint256"},{"indexed":false,"name":"balance","type":"uint256"}],"name":"Deposit","type":"event"},{"anonymous":false,"inputs":[{"indexed":false,"name":"token","type":"address"},{"indexed":false,"name":"host","type":"address"},{"indexed":false,"name":"hunter","type":"address"},{"indexed":false,"name":"amount","type":"uint256"},{"indexed":false,"name":"timestamp","type":"uint64"}],"name":"Distribution","type":"event"},{"anonymous":false,"inputs":[],"name":"Pause","type":"event"},{"anonymous":false,"inputs":[],"name":"Unpause","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"name":"previousOwner","type":"address"},{"indexed":true,"name":"newOwner","type":"address"}],"name":"OwnershipTransferred","type":"event"}];
        
        this.handleSubmit = this.handleSubmit.bind(this);
    
    }
    
    componentWillMount() {
        // could also do inline in base_admin.html to keep out of public webpack.js
        
        /*
        const scr = document.createElement("script");

        scr.src = "/static/js/abi-decoder.js";
        scr.async = false;

        document.head.appendChild(scr);
        */
    }

    handleSubmit() {
        abiDecoder.addABI(this.zeroxBountyABI);
        
        var code = this.refs.code.value;
        
        this.refs.data_encoded.innerText = code;
        this.refs.data_decoded.innerText = JSON.stringify( abiDecoder.decodeMethod( code ) );
        
        web3.eth.getTransactionReceipt("0x7665815d5065c4895329d329484c45b68f478180a96fcbefc1238d2f2e124308", function(e, receipt) {
            this.setState( {
                decodedLogs  : JSON.stringify( receipt.logs,null,'\t' )
            });
        }.bind(this));
        
    }
    
    render() {    

        return (
            <div className="container center_this max_width_760">
            
                <form   ref     = "theForm"  
                    onSubmit = {this.handleSubmit}
                > 
                    <div className="form_td">
                        <div className ="inline_block">
                    code or Tx: 
                        </div>
                        <input ref="code" type="text" className = "form_input ht_175" />
        
                    </div>
                </form>
                            
                <input  type            = "button" 
                        ref             = "registerButton" 
                        className       = "button_sm form_submit" 
                        onClick         = { this.handleSubmit } 
                        defaultValue    = "decode it"
                />
                      
                      
                            
                <div className = "margin_30_0_0 align_left">
                    <h4>Encoded Data:</h4>
                    <div ref = "data_encoded" />
                </div>
                
                <div className = "margin_30_0_0 align_left">
                    <h4>Decoded:</h4>
                    <div ref = "data_decoded" />
                </div>
                            
                
                
               
                <div className = "m_top_30_pct align_left">
                    <h3>Here are some examples:</h3>
                        
                        <div>
                            { this.state.decodedLogs }
                        </div>
                            
                            
                        
                        <div className = "margin_30_0_0">
                        View hex values at: <a href="http://hextodecimal.com/index.php?hex=C8">http://hextodecimal.com/index.php?hex=C8</a>
                        </div>
                    </div>
            </div>
        )
    }
}


export default ABIchecker0xBounty;
